import api from "@beeldit/core/helpers/api";

async function store(endpoint: string, data: any) {
  return api.post(`/${endpoint}`, data);
}

export default store;
